import './ButtonGroup-10292330.css';

var classes = {"ButtonGroup":"prc-ButtonGroup-ButtonGroup-vcMeG"};

export { classes as default };
